import { Box } from '@wishket/design-system';
import { PropsWithChildren } from 'react';
import { twJoin } from 'tailwind-merge';

const GrassBodyContainer = ({ children }: PropsWithChildren) => {
  return (
    <Box
      id="grass-body-container"
      className={twJoin(
        'flex h-[150px] w-full overflow-x-scroll rounded-2xl bg-w-white scrollbar-list',
        'desktop:h-[158px]'
      )}
    >
      {children}
    </Box>
  );
};

export default GrassBodyContainer;
